import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/track_usage"
import { MetaVars } from "../lib/helpers"

const findFirstMatchingAncestor = (rootElement, matcherFn) => {
  if (matcherFn(rootElement)) return rootElement
  if (rootElement.parentElement) return findFirstMatchingAncestor(rootElement.parentElement, matcherFn)

  return null
}

// Every element carrying data-controller="helpscout-beacon" (body + each
// "Learn more" link) runs connect(), but Beacon is a page-wide singleton —
// re-initializing logs "Beacon has already been initialized" once per link.
let initialized = false

export default class extends Controller {
  static values = {
    articles: String,
    term: String,
    articleType: String,
    articleId: String,
    route: String
  }

  connect() {
    if (!window.Beacon || initialized) return
    initialized = true

    window.Beacon('init', '9a511ebb-b4d1-489d-9ea7-3ba8bbc6d023')

    // Beacon's default z-index sits under Bootstrap's modal ($zindex-modal:
    // 1055), so "Learn more" inside a modal opened it behind the modal.
    window.Beacon('config', { display: { zIndex: 1060 } })

    if (MetaVars.userId && MetaVars.beaconSignature) {
      window.Beacon('identify', {
        name: MetaVars.userName,
        email: MetaVars.userEmail,
        signature: MetaVars.beaconSignature
      })
    }
  }

  open(event) {
    this.preventDefaultHandler(event)

    this.trackHelp("open")

    window.Beacon('open')
  }

  close(event) {
    this.preventDefaultHandler(event)

    // Don't interfere with beacon's close button handler
    if (findFirstMatchingAncestor(event.target, e => e && e.dataset && e.dataset.cy === "beacon-close-button")) return

    window.Beacon('close')
  }

  toggle(event) {
    this.preventDefaultHandler(event)

    this.trackHelp("toggle")

    window.Beacon('toggle')
  }

  suggest(event) {
    this.preventDefaultHandler(event)

    this.trackHelp("suggest")

    window.Beacon('search', this.articlesValue)
  }

  search(event) {
    this.preventDefaultHandler(event)

    this.trackHelp("search")

    window.Beacon('search', this.termValue)
  }

  article(event) {
    this.preventDefaultHandler(event)

    this.trackHelp("article")

    const type = this.articleTypeValue
    const articleId = this.articleIdValue

    window.Beacon('article', articleId, { type })
  }

  navigate(event) {
    this.preventDefaultHandler(event)

    this.trackHelp("navigate")

    const route = this.routeValue
    window.Beacon('navigate', route)
  }

  trackHelp(via) {
    track("help_opened", this.articleIdValue ? { via, article: this.articleIdValue } : { via })
  }

  preventDefaultHandler(event) {
    // Ad blockers cancel the Beacon script, leaving the queueing stub from
    // BeaconComponent in place. Let the link's real href navigate instead.
    if (window.Beacon.blocked) return

    const { currentTarget } = event

    const isBodyTag = currentTarget.tagName !== "BODY"
    const targetIsElement = currentTarget === this.element

    if (isBodyTag && targetIsElement) {
      event.preventDefault()
    }
  }

}